import { useTranslation } from 'react-i18next'
import { TextArea } from '@/components/base/textarea/textarea'
import { Checkbox } from '@/components/ui/Checkbox'

interface DetailsStepProps {
  customData: string
  enableRestaurantDetection: boolean
  onCustomDataChange: (data: string) => void
  onEnableRestaurantDetectionChange: (enabled: boolean) => void
}

/**
 * Step 2: Business details
 * Allows users to provide additional context about their business.
 */
export function DetailsStep({
  customData,
  enableRestaurantDetection,
  onCustomDataChange,
  onEnableRestaurantDetectionChange,
}: DetailsStepProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          {t('resources.onboarding.details.title')}
        </h2>
        <p className="mt-1 text-base text-gray-600 dark:text-gray-400">
          {t('resources.onboarding.details.description')}
        </p>
      </div>

      {/* Custom data textarea */}
      <TextArea
        label={t('resources.onboarding.details.custom_data_label')}
        hint={t('resources.onboarding.details.custom_data_description')}
        placeholder={t('resources.onboarding.details.custom_data_placeholder')}
        rows={12}
        value={customData}
        onChange={onCustomDataChange}
      />

      {/* Restaurant detection checkbox */}
      <Checkbox
        isSelected={enableRestaurantDetection}
        onChange={onEnableRestaurantDetectionChange}
        label={t('resources.onboarding.details.restaurant_detection')}
        description={t('resources.onboarding.details.restaurant_detection_description')}
      />
    </div>
  )
}

export default DetailsStep
